import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { childInfo } from '../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class ParentChildrenService {
  // selectedChildrenId = new BehaviorSubject<string>('0');
  selectedChildren = new BehaviorSubject<string>(
    localStorage.getItem('childIndex')
      ? JSON.parse(localStorage.getItem('childIndex')!)
      : '0'
  );
  children = new BehaviorSubject<any>(
    localStorage.getItem('children')
      ? JSON.parse(localStorage.getItem('children')!)
      : []
  );
  childrenLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor() {}

  getSelectedChild(): childInfo {
    let selectedChild: childInfo = {
      zipcode: '',
      country: '',
      skype: '',
      haveAcademicCoaching: false,
      address: '',
      gender: 0,
      mobile: '',
      last_name: '',
      student_id: -1,
      first_name: '',
      haveTestPrep: false,
      email: '',
    };
    if (
      localStorage['roleId'] == 4 &&
      localStorage['selectedChild'] != undefined &&
      localStorage['selectedChild'] != null
    ) {
      selectedChild = JSON.parse(localStorage['selectedChild']);
    }
    return selectedChild;
  }

  // getSelectedChildrenId(): Observable<string> {
  //   return this.selectedChildrenId.asObservable();
  // }

  getSelectedChildren(): Observable<string> {
    return this.selectedChildren.asObservable();
  }

  setSelectedChildren(index: string) {
    this.selectedChildren.next(index);
    console.log(this.children.value[index]);
    // this.selectedChildrenId.next(this.children.value[index].student_id);
    // console.log(this.children.value[index].student_id);
  }

  getChildren(): Observable<any> {
    return this.children.asObservable();
  }

  setChildren(children: any) {
    this.children.next(children);
  }

  getChildrenLoading(): Observable<boolean> {
    return this.childrenLoading.asObservable();
  }

  setChildrenLoading(childrenLoading: boolean) {
    this.childrenLoading.next(childrenLoading);
  }
}
